module.exports = __webpack_public_path__ + "pnskfsquadron/img/fb-en.jpg?21e06f0a";